<template>
    <div class="font-inter antialiased">
        <div class="min-h-screen bg-gray-100 flex flex-col justify-between">
            <div v-if="!hasDismissedCookies" class="fixed bottom-4 md:bottom-6 w-full" style="z-index: 100;">
                <div class="
         text-white
            max-w-7xl
            mx-auto
            text-sm
            md:text-base
            px-4
            md:px-8
          ">
                    <div class="w-full bg-sky-600/95 rounded-lg shadow-lg backdrop-blur-sm
            flex
            justify-between
            items-center
            px-4
            md:px-6
            py-3">
                        <div>
                            We use cookies to make this site simpler. Learn more in our
                            <a :href="route('privacy')" class="cursor-pointer font-semibold">Privacy Policy</a>.
                        </div>
                        <div class="pl-4">
                            <XMarkIcon class="h-5 w-5 cursor-pointer" @click="dismissCookies()"/>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Logged in user quick links -->
            <div v-if="$page.props.auth.user"
                 class="sticky z-20 top-0 bg-slate-900 text-slate-200 flex justify-between items-center px-4 py-2 text-xs">

                <div class="flex justify-start items-center gap-2">
                    <Link :href="route('filament.admin.pages.dashboard')" class="block">
                        <img alt="Logo" class="w-auto h-5 mr-1 sm:mr-2" src="/images/titan-icon.png"/>
                    </Link>

                    <Link :href="route('filament.admin.pages.dashboard')"
                          class="flex items-center gap-1 h-5 p-1 bg-slate-800 rounded transition-colors hover:bg-slate-600 cursor-pointer">
                        <IconSpaceDashboard class="h-4 w-4"/>
                        <span class="hidden sm:inline">Dashboard</span>
                    </Link>
                    <Link v-if="event_group"
                          :href="route('filament.admin.resources.event-groups.view', { record: event_group.id })"
                          class="flex items-center gap-1 h-5 p-1 bg-slate-800 rounded transition-colors hover:bg-slate-600 cursor-pointer">
                        <IconEditSquareOutlineRounded class="h-4 w-4"/>
                        Edit<span class="hidden sm:inline"></span>
                    </Link>
                    <Link v-if="event" :href="route('filament.admin.resources.events.view', { record: event.id })"
                          class="flex items-center gap-1 h-5 p-1 bg-slate-800 rounded transition-colors hover:bg-slate-600 cursor-pointer">
                        <IconEditSquareOutlineRounded class="h-4 w-4"/>
                        Edit<span class="hidden sm:inline"> event</span>
                    </Link>
                </div>
                <button
                    class="flex items-center gap-1 h-5 p-1 bg-slate-800 rounded transition-colors hover:bg-slate-600 cursor-pointer"
                    @click.prevent="logout()">
                    <IconLogoutRounded class="h-4 w-4"/>
                    <span class="hidden sm:inline">Sign out</span>
                </button>
            </div>

            <nav :style="backgroundImageAttribute" class="bg-blue-200 border-b border-gray-100"
                 style="background-size: cover;">
                <!-- Primary Navigation Menu -->
                <!-- Logo -->
                <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div class="h-36 w-full">
                    </div>
                    <div class="hidden md:flex items-end justify-between my-5">
                        <Breadcrumbs/>
                        <a class="cursor-pointer" href="https://titanticketing.com" rel="noopener noreferrer"
                           target="_blank">
                            <div class="bg-white/90 flex items-center justify-end rounded p-1 pl-2 text-xs text-dark">
                                <div class="text-right">
                                    Powered by <br/>
                                    Titan Ticketing
                                </div>
                                <img alt="Titan Ticketing" class="h-8 w-auto ml-2" src="/images/titan-icon.png"/>
                            </div>
                        </a>
                    </div>
                    <div class="relative pointer-events-none">
                        <div class="absolute top-[-70px] left-0 right-0 flex justify-center">
                            <Link :href="route('events')" class="pointer-events-auto" style="z-index: 2;">
                                <div
                                    class="h-[140px] w-[140px] flex justify-center items-center rounded-full border border-white border-4 bg-indigo-600"
                                    style="background-image: url('/images/blurred-background-10.jpg'); background-size: cover; background-position: top right;">
                                    <!-- <div
                                    class="h-[140px] w-[140px] flex justify-center items-center rounded-full border border-white border-4 bg-indigo-600"
                                    style="background-image: url('/images/megaslam.jpg'); background-size: cover;> -->
                                    <BreezeApplicationLogo
                                        :class="$page.props.currentCompany.id === '9aad5887-d338-4647-a0f1-ffa2f327e6e9' ? 'w-full' : 'w-28'"
                                        class="block h-auto"/>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>

            </nav>

            <!-- Page Heading -->
            <header class="bg-white shadow">
                <!-- <div class="md:hidden w-full h-[50px]"></div> -->
                <div class="
          max-w-7xl
          mx-auto
          py-6
          px-4
          sm:px-6
          lg:px-14
          text-center
          md:text-left
        ">
                    <div class="md:w-5/12 pt-[55px] md:pt-0">
                        <slot name="header">

                            <h2 class="font-semibold text-lg md:text-xl text-gray-800 leading-tight">
                                {{ title ?? currentLink.label }}
                            </h2>
                        </slot>
                        <!-- <div>22 Events</div> -->
                    </div>
                </div>
            </header>

            <!-- Page Heading -->
            <!-- <header class="bg-white shadow" v-if="$slots.header">
              <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                <slot name="header" />
              </div>
            </header> -->

            <!-- Page Content -->
            <main class="mb-auto">
                <slot/>
            </main>

            <!-- Footer -->

            <div class="bg-white border-t border-gray-100 text-center md:text-left">
                <div class="max-w-7xl mx-auto px-4 py-10 sm:px-6 lg:px-8">
                    <div
                        class="grid md:grid-cols-4 grid-cols-1 gap-4 text-gray-500 pb-4 border-b justify-items-center md:justify-items-start">
                        <div class="md:col-span-2 text-sm">

                            <a class="cursor-pointer" href="https://titanticketing.com" rel="noopener noreferrer"
                               target="_blank">
                                <div class="bg-slate-100 flex items-center gap-3 rounded p-2 pr-4 text-sm text-dark">
                                    <img alt="Titan Ticketing" class="h-12 w-auto" src="/images/titan-icon.png"/>
                                    <div class="text-left">
                                        Powered by <br/>
                                        Titan Ticketing
                                    </div>
                                </div>
                            </a>

                            <!-- <div class="mb-2">Powered by</div>
                            <img src="/images/titan-ticketing-text-logo.png" class="h-auto w-60 mb-3" alt="Titan Ticketing" /> -->
                        </div>
                        <div>
                            <div>
                                <div class="font-semibold mb-1">Contact</div>
                                <div class="text-sm">
                                    Box office: {{ $page.props.currentCompany.phone }}<br/>
                                    <a :href="'mailto:' + $page.props.currentCompany.email">{{
                                            $page.props.currentCompany.email
                                        }}</a>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="font-semibold mb-1">Legal</div>
                            <div class="text-sm">
                                <!-- <div class="font-semibold mb-2 text-gray-800">Links</div> -->
                                <a :href="route('privacy')" class="cursor-pointer hover:text-blue-400">Privacy
                                    Policy</a>
                                <!-- <span class="mx-2">|</span> -->
                                <br/>
                                <a :href="route('terms')" class="cursor-pointer hover:text-blue-400">Terms and
                                    Conditions</a>
                                <!-- <span class="mx-2">|</span> -->
                                <br/>
                                <a :href="route('terms') + '#Refunds'" class="cursor-pointer hover:text-blue-400">Refunds
                                    Policy</a>
                            </div>
                        </div>
                    </div>
                    <div class="pt-3 text-sm text-gray-500 md:flex md:justify-between md:align-start">
                        <div>
                            <div>© 2024 Titan Ticketing Ltd. All rights reserved.</div>
                            <div>5 Palmers Road, London, United Kingdom, SW14 7NB</div>
                            <div>Company Registration No. 13969418</div>
                        </div>
                        <div class="flex justify-center md:justify-start pt-4 md:pt-0">
                            <img alt="Titan Ticketing Ltd" class="h-4" src="/images/titan-icon.png">
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="fixed bottom-0 right-0 px-12 pb-28">
            <div class="p-6 bg-white shadow rounded sm:rounded-lg">
              We use cookies for to make this site simpler. Learn more in our
              <a
                class="cursor-pointer text-blue-500 hover:text-blue-400"
                :href="route('privacy')"
                >Privacy Policy</a
              >.
            </div>
          </div> -->
        </div>
    </div>
</template>

<script>
import BreezeApplicationLogo from "@/Components/ToSort/ApplicationLogo.vue";
import BreezeDropdown from "@/Components/ToSort/Dropdown.vue";
import BreezeDropdownLink from "@/Components/ToSort/DropdownLink.vue";
import BreezeNavLink from "@/Components/ToSort/NavLink.vue";
import BreezeResponsiveNavLink from "@/Components/ToSort/ResponsiveNavLink.vue";
import Breadcrumbs from "@/Components/ToSort/Breadcrumbs.vue";
import {XMarkIcon} from "@heroicons/vue/24/solid";
import {usePage} from "@inertiajs/vue3";
import { router } from "@inertiajs/vue3";
import axios from "axios";
import toastNotificationMixin from "@/mixins/toastNotificationMixin";
import {
    IconEditSquareOutlineRounded,
    IconLogoutRounded,
    IconSpaceDashboard
} from '@iconify-prerendered/vue-material-symbols'

export default {
    components: {
        BreezeApplicationLogo,
        BreezeDropdown,
        BreezeDropdownLink,
        BreezeNavLink,
        BreezeResponsiveNavLink,
        Breadcrumbs,
        XMarkIcon,
        IconEditSquareOutlineRounded,
        IconSpaceDashboard, IconLogoutRounded,
    },

    data() {
        return {
            showingNavigationDropdown: false,
            hasDismissedCookies: false,
        };
    },

    mounted() {
        this.hasDismissedCookies =
            usePage().props.session.has_dismissed_cookies;
    },

    methods: {
        dismissCookies() {
            this.hasDismissedCookies = true;

            // const axios = axios;

            axios.post(this.route("dismiss-cookies"));
        },
        logout() {
            router.post(route('logout'));
        }
    },

    computed: {
        backgroundImageAttribute() {
            return (
                "background-image: url('" +
                (this.$page.props.currentCompany.background_image_src ?? "/images/blurred-background.jpg") +
                "'); background-position: " + (this.$page.props.currentCompany.id === '9aad5887-d338-4647-a0f1-ffa2f327e6e9' ? "bottom" : "top") + ";"
            );
        },
    },

    watch: {
        // TODO: this should be moved if we want to track other sections or the structure changes
        "$page.url": {
            handler(to, from) {
                this.$gtag.pageview(to);
            },
        },
    },

    props: ['event', 'event_group'],

    mixins: [toastNotificationMixin],
};
</script>
